/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  FieldType,
  GetResourceFieldTypesParams,
  GetResourceParams,
  ResourceDto,
  ResourceDtoPagination,
  ResourcePageRequest
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetResourceFieldTypesUrl = (params?: GetResourceFieldTypesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Resource/GetResourceFieldTypes?${stringifiedParams}` : `/api/Resource/GetResourceFieldTypes`
}

export const getResourceFieldTypes = async (params?: GetResourceFieldTypesParams, options?: RequestInit): Promise<FieldType[]> => {
  
  return customInstance<FieldType[]>(getGetResourceFieldTypesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetResourceFieldTypesQueryKey = (params?: GetResourceFieldTypesParams,) => {
    return [
    `/api/Resource/GetResourceFieldTypes`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetResourceFieldTypesQueryOptions = <TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(params?: GetResourceFieldTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceFieldTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceFieldTypes>>> = ({ signal }) => getResourceFieldTypes(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceFieldTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceFieldTypes>>>
export type GetResourceFieldTypesQueryError = ErrorType<unknown>


export function useGetResourceFieldTypes<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceFieldTypesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceFieldTypes>>,
          TError,
          Awaited<ReturnType<typeof getResourceFieldTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceFieldTypes<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params?: GetResourceFieldTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResourceFieldTypes>>,
          TError,
          Awaited<ReturnType<typeof getResourceFieldTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceFieldTypes<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params?: GetResourceFieldTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceFieldTypes<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params?: GetResourceFieldTypesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceFieldTypesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetResourceFieldTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(params?: GetResourceFieldTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceFieldTypesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourceFieldTypes>>> = ({ signal }) => getResourceFieldTypes(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceFieldTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResourceFieldTypes>>>
export type GetResourceFieldTypesSuspenseQueryError = ErrorType<unknown>


export function useGetResourceFieldTypesSuspense<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceFieldTypesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceFieldTypesSuspense<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params?: GetResourceFieldTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceFieldTypesSuspense<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params?: GetResourceFieldTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceFieldTypesSuspense<TData = Awaited<ReturnType<typeof getResourceFieldTypes>>, TError = ErrorType<unknown>>(
 params?: GetResourceFieldTypesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResourceFieldTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceFieldTypesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPaginatedResourcesUrl = () => {


  

  return `/api/Resource/GetPaginatedResources`
}

export const getPaginatedResources = async (resourcePageRequest: ResourcePageRequest, options?: RequestInit): Promise<ResourceDtoPagination> => {
  
  return customInstance<ResourceDtoPagination>(getGetPaginatedResourcesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      resourcePageRequest,)
  }
);}




export const getGetPaginatedResourcesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResources>>, TError,{data: BodyType<ResourcePageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResources>>, TError,{data: BodyType<ResourcePageRequest>}, TContext> => {

const mutationKey = ['getPaginatedResources'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedResources>>, {data: BodyType<ResourcePageRequest>}> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedResources(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedResourcesMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedResources>>>
    export type GetPaginatedResourcesMutationBody = BodyType<ResourcePageRequest>
    export type GetPaginatedResourcesMutationError = ErrorType<unknown>

    export const useGetPaginatedResources = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedResources>>, TError,{data: BodyType<ResourcePageRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedResources>>,
        TError,
        {data: BodyType<ResourcePageRequest>},
        TContext
      > => {

      const mutationOptions = getGetPaginatedResourcesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getGetResourceUrl = (params?: GetResourceParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Resource/GetResource?${stringifiedParams}` : `/api/Resource/GetResource`
}

export const getResource = async (params?: GetResourceParams, options?: RequestInit): Promise<ResourceDto> => {
  
  return customInstance<ResourceDto>(getGetResourceUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetResourceQueryKey = (params?: GetResourceParams,) => {
    return [
    `/api/Resource/GetResource`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetResourceQueryOptions = <TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(params?: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResource>>> = ({ signal }) => getResource(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceQueryResult = NonNullable<Awaited<ReturnType<typeof getResource>>>
export type GetResourceQueryError = ErrorType<unknown>


export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResource>>,
          TError,
          Awaited<ReturnType<typeof getResource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params?: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getResource>>,
          TError,
          Awaited<ReturnType<typeof getResource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params?: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResource<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params?: GetResourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetResourceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(params?: GetResourceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResource>>> = ({ signal }) => getResource(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetResourceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getResource>>>
export type GetResourceSuspenseQueryError = ErrorType<unknown>


export function useGetResourceSuspense<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params: undefined |  GetResourceParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceSuspense<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params?: GetResourceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetResourceSuspense<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params?: GetResourceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetResourceSuspense<TData = Awaited<ReturnType<typeof getResource>>, TError = ErrorType<unknown>>(
 params?: GetResourceParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getResource>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetResourceSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




